import src from "IMAGE";
export default { src, width: 1440, height: 648, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAQUlEQVR42nWMSwoAIAhEu/9J+5eBusu0VRQtBmXeY1wGmmWwnMnAEhrt627ByqjQF5QE9AqpK6woQWP/dyEqNGEBhNt6OYMCZZIAAAAASUVORK5CYII="};
